var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":"私密专题仅代表不可以被搜索，不代表完全无法被别人查看"}},[_c('a-tag',{style:({'margin-left': '5px'}),attrs:{"color":"pink"}},[_vm._v("私密")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }